<template>
  <div v-if="facilities">
    <h2 class="title gymHeader">Facilities</h2>
    <hr class="m-0" />
    <div :class="[ 'is-flex', 'p-2', 'facility-wrapper', { 'gym-card-facilities' : is_gym_card } ]">
      <div
        class="p-2"
        v-for="(facility, index) in facilities"
        :key="index"
      >
        <span class="tag is-large">{{facility.name}}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    facilities: Array,
    is_gym_card: {
      type: Boolean,
      default: false,
    }
  }
};
</script>

<style scoped>
@media (max-width: 768px) {
  .gymHeader {
    font-weight: 600;
    font-size: 1.5rem;
    margin: 1rem;
    padding: 0;
  }
}

.facility-wrapper {
  flex-direction: row;
  flex-wrap: wrap;
}

.gym-card-facilities {
  max-height: 166px !important;
  overflow: hidden;
}

hr {
  width: 90%;
  margin-left: 1rem;
}

@media (max-width: 768px) {
 hr {
   width: 100%;
   margin: 0;
 }
}

li {
  color: #00c5fd;
  font-size: 1.5rem;
}

</style>